/**
 * Generic API request handler with error handling
 */

import { APP_CONFIG } from "../../../configs/config.js";

const API_BASE_URL = APP_CONFIG.API_BASE_URL;

export const apiRequest = async (endpoint, options = {}) => {
  const baseUrl = API_BASE_URL.replace(/\/$/, "");
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  const url = `${baseUrl}${cleanEndpoint}`;

  const isFormData = options.body instanceof FormData;

  const defaultOptions = {
    headers: isFormData
      ? {}
      : {
          "Content-Type": "application/json",
        },
  };

  const config = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, config);

    const contentType = response.headers.get("content-type");
    let data;

    if (contentType && contentType.includes("application/json")) {
      data = await response.json();
    } else {
      const text = await response.text();
      console.error("Non-JSON response received:", text.substring(0, 200));
      data = {
        detail: text.includes("<!DOCTYPE")
          ? "Server returned HTML instead of JSON. Please check backend server."
          : `Unexpected response format: ${text.substring(0, 100)}...`,
      };
    }

    if (!response.ok) {
      let errorMessage = `HTTP ${response.status}: ${response.statusText}`;

      if (data.detail) {
        if (Array.isArray(data.detail)) {
          errorMessage = data.detail
            .map((err) => {
              if (typeof err === "string") return err;
              if (err.msg) return err.msg;
              if (err.message) return err.message;
              if (err.loc && err.msg) return `${err.loc.join(".")}: ${err.msg}`;
              return "Validation error";
            })
            .join("; ");
        } else if (typeof data.detail === "string") {
          errorMessage = data.detail;
        } else {
          errorMessage = "Validation error occurred";
        }
      } else if (data.message) {
        errorMessage = data.message;
      } else if (data.error) {
        errorMessage = data.error;
      }

      throw new Error(errorMessage);
    }

    const success = data.success !== undefined ? data.success : true;

    return {
      success: success,
      data: data.data || data,
    };
  } catch (error) {
    console.error(`API Error [${endpoint}]:`, error.message);

    let errorMessage = error.message;

    if (error.message.includes("Failed to fetch")) {
      errorMessage = `Unable to connect to server. Please check if the backend is running at ${API_BASE_URL.replace("/api/v1", "")}.`;
    } else if (error.message.includes("JSON")) {
      errorMessage = "Server response error. Please try again.";
    }

    if (typeof errorMessage !== "string") {
      errorMessage = "An unexpected error occurred";
    }

    return {
      success: false,
      error: errorMessage || "An unexpected error occurred",
    };
  }
};
